module.exports = __webpack_public_path__ + "static/queen-hms-elizabeth.445ed83a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/queen-hms-elizabeth.jpg
// module id = 481
// module chunks = 210008665022385